type SentryEnv = 'local' | 'dev' | 'stage' | 'prod';

export const env = {
  BASE_URL: import.meta.env.VITE_APP_API_SERVER as string,
  SENTRY_DSN: import.meta.env.VITE_APP_SENTRY_DSN as string,
  SENTRY_ENV: (import.meta.env.VITE_APP_SENTRY_ENV ?? 'local') as SentryEnv,
  SENTRY_DEBUG: JSON.parse(
    import.meta.env.VITE_APP_SENTRY_DEBUG ?? 'false',
  ) as boolean,
  SENTRY_WITH_REDUX: JSON.parse(
    import.meta.env.VITE_APP_SENTRY_WITH_REDUX ?? 'false',
  ) as boolean,
  LOGROCKET_ID: import.meta.env.VITE_APP_LOGROCKET_ID as string | undefined,
};
export const isStaging = import.meta.env.VITE_APP_ENV === 'staging';
